import { CUBE_HCP_CONSENT_CHANNEL_TOPIC } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { FilterConfigDynamic } from '@/types/filter';

const DIMENSION = `${CUBE_HCP_CONSENT_CHANNEL_TOPIC}.topic_name`;

const consentTopicNameFilter: FilterConfigDynamic = {
  label: 'main.aggregatedConsent.filters.topicName.label',
  placeholder: 'main.aggregatedConsent.filters.topicName.placeholder',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  useFloatingLabel: true,
  sourceCube: CUBE_HCP_CONSENT_CHANNEL_TOPIC,
  getOptionsQuery: ({ sourceCube }) => ({
    dimensions: [DIMENSION],
    limit: 1000,
    filters: [{ member: `${sourceCube}.hcp_bk`, operator: 'set' }],
  }),
  mapResult: mapDimensionToOption(DIMENSION, value => (value === 'N/A' ? 'Not defined' : value)),
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    return { member: DIMENSION, operator: 'equals', values: [...v] };
  },
};

export default consentTopicNameFilter;
